<script lang="ts">
  import Table from "./lib/Table.svelte";
  export let archive = false;
</script>

<main>
  <Table {archive}/>
</main>

<svelte:head>
  <style>
    [data-tooltip] {
      position: relative;
      z-index: 2;
    }

    [data-tooltip]:before,
    [data-tooltip]:after {
      visibility: hidden;
      opacity: 0;
      pointer-events: none;
      transition: 0.2s ease-out;
      transform: translate(-50%, 5px);
    }

    [data-tooltip]:before {
      position: absolute;
      top: 100%;
      left: 50%;
      margin-top: 5px;
      padding: 7px;
      min-width: 150px;
      max-width: 250px;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      background-color: #000;
      background-color: hsla(0, 0%, 20%, 0.9);
      color: #fff;
      content: attr(data-tooltip);
      text-align: center;
      font-size: 14px;
      line-height: 1.2;
      transition: 0.2s ease-out;
    }

    [data-tooltip]:after {
      position: absolute;
      top: 100%;
      left: 50%;
      width: 0;
      border-bottom: 5px solid #000;
      border-bottom: 5px solid hsla(0, 0%, 20%, 0.9);
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
      content: " ";
      font-size: 0;
      line-height: 0;
    }
    @media (min-width: 992px) { 
      [data-tooltip]:hover:before,
      [data-tooltip]:hover:after {
        visibility: visible;
        opacity: 1;
        transform: translate(-50%, 0);
      }
      [data-tooltip="false"]:hover:before,
      [data-tooltip="false"]:hover:after {
        visibility: hidden;
        opacity: 0;
      } 
    }
  </style>
</svelte:head>
